import { clearToken, getToken, setToken } from "@/services/token";
import { jwtDecode } from "jwt-decode"

export const getSession = () => {
  const token = getToken()
  if (!token) {
    return null
  }

  return jwtDecode<Session>(token);
}

export const isLoggedIn = () => {
  return !!getToken()
}

export const tryLogin = () => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');

  if (token) {
    setToken(token);
    window.location.assign('/')
    return true
  }

  return false
}

export const logout = () => {
  clearToken();
  window.location.assign(import.meta.env.VITE_APP_LOGIN_URL)
}
